// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "3938") return "js/3938." + __webpack_require__.h() + ".js";
if (chunkId === "8955") return "js/8955." + __webpack_require__.h() + ".js";
  // return url for filenames based on template
  return "js/" + chunkId + "." + __webpack_require__.h() + ".chunk.js"
}